export const isKiosk = () => {
  const subdomain = process.env.KIOSK_DOMAIN;
  if (subdomain) {
    return typeof window !== 'undefined'
      ? window.location.host.indexOf(subdomain) !== -1
      : false;
  }
  return false;
};
